((function ($) {
  if (!$.uniqBase) {
    $.uniqBase = {};
  };

  $.uniqBase.FancyBoxWrapper = function (el, options, index) {
    // To avoid scope issues, use 'base' instead of 'this'
    // to reference this class from internal events and functions.
    var base = this;

    // Access to jQuery and DOM versions of element
    base.$el = $(el);
    base.el = el;

    // Add a reverse reference to the DOM object
    base.$el.data('uniqBase.FancyBoxWrapper', base);

    base.init = function () {
      base.wrapperOptions = {};

      base.options = $.extend({},
        $.uniqBase.FancyBoxWrapper.defaultOptions, options);
      base.index = index;

      if (base.options.groupName !== '') {
        base.setGroup();
      }
      base.setCustomCaption();

      var fancyboxOptions = $.extend({},
        $.uniqBase.FancyBoxWrapper.defaultOptions.fancyboxOptions, base.wrapperOptions);

      base.$el.find('[data-fancybox="' + base.options.groupName + base.index + '"]').fancybox(fancyboxOptions);

    };
    base.init();
  };

  /**
   * @method setGroup
   * @desc set attributes to group elements for image gallery
   */
  $.uniqBase.FancyBoxWrapper.prototype.setGroup = function () {
    var base = this;

    base.$el.find(base.options.sliderItems).attr('data-fancybox', base.options.groupName + base.index);
  };

  /**
   * @method loadItems
   * @desc load new items
   */
  $.uniqBase.FancyBoxWrapper.prototype.setCustomCaption = function () {
    var base = this;

    base.wrapperOptions.caption = function () {
      return $(this).next('figcaption').html();
    };
  };

  $.uniqBase.FancyBoxWrapper.defaultOptions = {
    groupName: '',
    fancyboxOptions: {},
    sliderItems: '.owl-item:not(.cloned) .item > a'
  };

  $.fn.uniqBase_fancyBoxWrapper = function (options) {
    return this.each(function (index) {
      (new $.uniqBase.FancyBoxWrapper(this, options, index));
    });
  };
})(jQuery));
